import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ConfigService } from '../../config.service';
import { AESService } from '../../encryption/aes.service';

@Injectable()
export class CreateGroupService {

  constructor(public http: HttpClient, public config: ConfigService,private Cryptography : AESService) {
    
  }
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.Cryptography.getItem('accesstoken',true) })
  };
  groupCreate(user: any): Observable<any> {
    return this.http.post<any>(`${this.config.baseURL}/group/creategroup`, user, this.httpOptions).map((res) => { return res });
  }

  getAllOptions(): Observable<any> {
    return this.http.get<any>(`${this.config.baseURL}/data/getAllOptions`, this.httpOptions).map((res) => { return res });
  }

  createGroupAttrWithOpt(body: any): Observable<any> {
    return this.http.post<any>(`${this.config.baseURL}/function/createFunction`, body, this.httpOptions).map((res) => { return res });
  }

  getGroupAttrWithOpt(id): Observable<any> {
    return this.http.get<any>(`${this.config.baseURL}/data/getGroupWithGroupAttributes/${id}`, this.httpOptions).map((res) => { return res });
  }

  updateGroupAttrWithOpt(body: any): Observable<any> {
    return this.http.put<any>(`${this.config.baseURL}/function/editFunction`, body, this.httpOptions).map((res) => { return res });
  }
}
